export default {
    isLoading: false,
    isAgree: false,
    isFixed: false,
}



// WEBPACK FOOTER //
// ./src/vuex/state.js